"use client"

import { InlineAssignmentSelect } from "@ui/forms/inline"
import { FormItem, FormLabel, FormMessage } from "@ui/shad"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

interface AssignmentSelectFieldProps<T extends FieldValues> {
  id: string
  field: ControllerRenderProps<T, Path<T>>
  bookId?: string
  label?: string
}

export function AssignmentSelectField<T extends FieldValues>({
  id,
  field,
  bookId,
  label = "Assigned to",
}: AssignmentSelectFieldProps<T>) {
  const assignment = typeof field.value === "string" ? field.value : ""
  const selectedUserId = assignment.startsWith("user:") ? assignment.slice(5) : null
  const selectedTeamId = assignment.startsWith("team:") ? assignment.slice(5) : null

  return (
    <FormItem>
      <FormLabel htmlFor={id}>{label}</FormLabel>
      <InlineAssignmentSelect
        id={id}
        bookId={bookId}
        hideLabel
        selectedUserId={selectedUserId}
        selectedTeamId={selectedTeamId}
        variant="field"
        onSave={(userId, teamId) => {
          field.onChange(userId ? `user:${userId}` : teamId ? `team:${teamId}` : "")
        }}
      />
      <FormMessage />
    </FormItem>
  )
}
